import api from './api'

export default class BaseService {
  static getCountries() {
    return api.get('/countries')
  }

  static getBanks(country, psuType) {
    const params = {}
    if (country) {
      params.country = country
    }
    if (psuType) {
      params.psu_type = psuType
    }
    return api.get('/banks', { params })
  }
}
